import { Link } from 'react-router-dom';
import '../../assets/css/single_cource/course-video.css';
import c1 from '../../components/assets/img/thumbnail.jpeg'


function CourseVideo() {
  return (
    <>
      <div className='flexColStartStart course-detail course-video'>
        <h2>جلسات دوره</h2>

        <Link to='/' className='flexRowBetCenter'>
            <div className='flexRowBetCenter'>
                <div>
                    <img  src={c1} alt="" />
                </div>
                <div className='flexColStartStart'>
                    <span>جلسه اول</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width='.9rem' height='.9rem' fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        01:26:16
                        </span>
                </div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem"><path fill="rgb(229, 231, 235)" d="M6.175 21.925Q5.275 21.925 4.65 21.3Q4.025 20.675 4.025 19.775V10.075Q4.025 9.2 4.65 8.562Q5.275 7.925 6.175 7.925H7.075V6.15Q7.075 4.1 8.513 2.662Q9.95 1.225 12 1.225Q14.05 1.225 15.488 2.662Q16.925 4.1 16.925 6.15V7.925H17.825Q18.725 7.925 19.35 8.562Q19.975 9.2 19.975 10.075V19.775Q19.975 20.675 19.35 21.3Q18.725 21.925 17.825 21.925ZM9.225 7.925H14.775V6.15Q14.775 5 13.963 4.188Q13.15 3.375 12 3.375Q10.85 3.375 10.038 4.188Q9.225 5 9.225 6.15ZM12 16.85Q12.8 16.85 13.363 16.288Q13.925 15.725 13.925 14.925Q13.925 14.15 13.363 13.575Q12.8 13 12 13Q11.2 13 10.638 13.575Q10.075 14.15 10.075 14.925Q10.075 15.725 10.638 16.288Q11.2 16.85 12 16.85Z"></path></svg>
        </Link>


      </div>
    </>
  );
}

export default CourseVideo;